import { isString } from 'lodash';

export const capitalizeFirstLetter = (string) => {
  if (!string) return '';
  const [first, ...rest] = string.toLowerCase();
  return [first.toUpperCase(), ...rest].join('');
};

export const isLink = (str) => {
  return /^(http|https)?:\/\//i.test(str);
};

export const normalizeStr = (str) => {
  if (!str) return '';

  /* Normalize string ex: 'Crême Brûlée' => 'cremebrulee' */
  return str
    .toString()
    .toLowerCase()
    .normalize('NFD') // Transform string into unicode normalized form
    .replace(/[_]+/g, '') // collapse and replace _
    .replace(/[^a-z -]/g, '') // remove invalid chars
    .replace(/\s+/g, '') // collapse whitespace
    .replace(/-+/g, '') // collapse dashes
    .replace(/^-+/, '') // trim - from start of text
    .replace(/-+$/, ''); // trim - from end of text
};

/**
 * @description Process a string to uppercase it and convert special characters
 * @example processString('Jérôme') => 'JEROME'
 * @example processString('Jean-François') => 'JEAN-FRANCOIS'
 * @param {String} input
 * @returns String
 */
export const processString = (input) => {
  if (!isString(input)) return '';

  // Convert the string to uppercase
  const upperCaseString = input.toUpperCase();

  // Normalize the string to replace special characters with their non-accented versions
  const normalizedString = upperCaseString.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

  // Keep hyphens and spaces
  const processedString = normalizedString.replace(/[^a-zA-Z0-9- ]/g, '');

  return processedString;
};
